// src/asset-delivery/utils/toCleanCdnUrl.ts

import { ASSET_CDN_ORIGIN } from "../config";

export function toCleanCdnUrl(url?: string | null): string | null {
  if (!url) return null;

  const raw = String(url).trim();
  if (!raw) return null;

  // Keep CDN URLs stable by removing signed/cache query params.
  if (raw.startsWith(ASSET_CDN_ORIGIN)) {
    const clean = raw.split("?")[0];
    return clean || null;
  }

  const s3Marker = "amazonaws.com/";
  const idx = raw.indexOf(s3Marker);

  if (idx !== -1) {
    const after = raw.slice(idx + s3Marker.length);
    const key = after.split("?")[0]?.replace(/^\/+/, "");
    return key ? `${ASSET_CDN_ORIGIN}/${key}` : null;
  }

  if (!raw.startsWith("http")) {
    const key = raw.split("?")[0]?.replace(/^\/+/, "");
    return key ? `${ASSET_CDN_ORIGIN}/${key}` : null;
  }

  return null;
}